module.exports = __webpack_public_path__ + "img/arrow-next.417b5e53.svg";